import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { filter } from 'lodash';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Tooltip, Button, IconButton, Typography } from '@material-ui/core';
import IconSquiggly from 'icons/IconSquiggly';
import SquigglyTemplatesMenu from '../SquigglyTemplatesMenu';

const styles = (theme) => {
  const {
    custom: {
      palette: { colorSupportSteel, colorGrayishBlue },
      fontSizes,
    },
    palette: {
      common: { white },
      primary,
    },
    spacing: { unit },
  } = theme;

  return {
    button: {
      backgroundColor: `${white} !important`,
      border: `1px solid ${colorGrayishBlue}`,
      borderRadius: unit / 2,
      height: 40,
      width: 153,
      whiteSpace: 'nowrap',
    },
    buttonIcon: {
      color: colorSupportSteel,
      fontSize: fontSizes.body,
    },
    buttonLabel: {
      color: primary.main,
      fontWeight: 500,
      padding: `0px ${unit}px`,
    },
    iconButton: {
      color: primary.main,
    },
    hidden: {
      display: 'none !important',
    },
  };
};

class SquigglyTemplatesButton extends PureComponent {
  state = {
    menuAnchor: null,
    options: false,
  };

  handleButtonClick = (event) => {
    const { menuAnchor } = this.state;

    if (!event || menuAnchor) {
      this.setState({ menuAnchor: null });
    } else if (!menuAnchor) {
      this.setState({ menuAnchor: event.currentTarget });
    }
  };

  // mock code - temp
  componentWillUpdate(nextProps, nextState) {
    const { squigglyTemplates } = this.props;
    const { menuAnchor } = this.state;

    if (
      (nextProps.squigglyTemplates && nextProps.squigglyTemplates !== squigglyTemplates) ||
      (nextState.menuAnchor && menuAnchor !== nextState.menuAnchor)
    ) {
      this.setState({ options: nextProps.squigglyTemplates });
    }
  }

  handleMenuItemClick = (item) => {
    const { onSquigglyTemplateSelected } = this.props;

    onSquigglyTemplateSelected(item);

    this.handleButtonClick();
  };

  // mock code - temp
  handleSquigglyTemplatesFilter = (value) => {
    const { squigglyTemplates } = this.props;
    const squigglyRegexp = new RegExp(`(${value})`, 'i');

    const options = filter(
      squigglyTemplates,
      (squiggly) => squigglyRegexp.test(squiggly.id) || squigglyRegexp.test(squiggly.name),
    );

    this.setState({ options: value ? options : squigglyTemplates });
  };

  renderButton() {
    const {
      classes,
      className,
      disabled,
      hide,
      iconButtonMode,
      label,
      IconProps,
      tooltip = 'Insert Squiggly',
    } = this.props;

    if (iconButtonMode) {
      return (
        <Tooltip title={tooltip}>
          <div>
            <IconButton
              aria-label={label || 'Insert Squiggly'}
              className={classnames(classes.iconButton, className, { [classes.hidden]: hide })}
              disabled={disabled || false}
              onClick={this.handleButtonClick}
              type="button"
            >
              <IconSquiggly {...IconProps} />
            </IconButton>
          </div>
        </Tooltip>
      );
    }

    return (
      <Button
        aria-label={label || 'Insert Squiggly'}
        className={classnames(classes.button, className, { [classes.hidden]: hide })}
        disabled={disabled || false}
        disableFocusRipple
        disableRipple
        onClick={this.handleButtonClick}
        type="button"
        variant="outlined"
      >
        <IconSquiggly className={classes.buttonIcon} {...IconProps} />
        <Typography className={classes.buttonLabel}>{label || ''}</Typography>
      </Button>
    );
  }

  render() {
    const { menuAnchor, options } = this.state;

    return (
      <>
        {this.renderButton()}
        <SquigglyTemplatesMenu
          menuAnchor={menuAnchor}
          onClickAway={this.handleButtonClick}
          onFilter={this.handleSquigglyTemplatesFilter}
          onSelect={this.handleMenuItemClick}
          squigglyTemplates={options || []}
        />
      </>
    );
  }
}

SquigglyTemplatesButton.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hide: PropTypes.bool,
  iconButtonMode: PropTypes.bool,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  onSquigglyTemplateSelected: PropTypes.func.isRequired,
  squigglyTemplates: PropTypes.array.isRequired,
  IconProps: PropTypes.object,
};

SquigglyTemplatesButton.defaultProps = {
  className: '',
  disabled: false,
  hide: false,
  iconButtonMode: false,
  label: '',
  IconProps: undefined,
};

export default withStyles(styles)(SquigglyTemplatesButton);
